import React from 'react';

import Icon from '../Icon/Icon';

const BellIconV2 = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <path
                d='M46.7679 40.9944C46.0424 40.9944 45.4489 40.392 45.4489 39.6557V26.0058C45.4489 19.1114 40.8237 13.1636 34.3773 11.9588V10.3753C34.3773 8.95287 32.9848 8 31.5999 8C30.1985 8 28.835 8.9696 28.835 10.3753V11.9588C22.3886 13.1636 17.7508 19.1114 17.7508 26.0058V39.6557C17.7508 40.392 17.1573 40.9944 16.4319 40.9944C14.8326 40.9944 13.3323 42.0989 13.052 43.7053C12.6893 45.7804 14.2721 47.5876 16.2505 47.5876H46.9657C48.9442 47.5876 50.5104 45.7804 50.1642 43.7053C49.8839 42.0989 48.4001 40.9944 46.7844 40.9944H46.7679Z'
                fill='#393E44'
            />
            <path
                d='M51.004 18.491C51.004 22.4265 47.8137 25.6168 43.8782 25.6168C39.9428 25.6168 36.7524 22.4265 36.7524 18.491C36.7524 14.5556 39.9428 11.3652 43.8782 11.3652C47.8137 11.3652 51.004 14.5556 51.004 18.491Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M43.8782 12.6152C40.6331 12.6152 38.0024 15.2459 38.0024 18.491C38.0024 21.7361 40.6331 24.3668 43.8782 24.3668C47.1233 24.3668 49.754 21.7361 49.754 18.491C49.754 15.2459 47.1233 12.6152 43.8782 12.6152ZM35.5024 18.491C35.5024 13.8652 39.2524 10.1152 43.8782 10.1152C48.504 10.1152 52.254 13.8652 52.254 18.491C52.254 23.1168 48.504 26.8668 43.8782 26.8668C39.2524 26.8668 35.5024 23.1168 35.5024 18.491Z'
                fill='#FFFDFB'
            />
            <path
                d='M38 50C38 51.5913 37.3679 53.1174 36.2426 54.2426C35.1174 55.3679 33.5913 56 32 56C30.4087 56 28.8826 55.3679 27.7574 54.2426C26.6321 53.1174 26 51.5913 26 50L38 50Z'
                fill='#00D1D2'
            />
        </Icon>
    );
};

export default BellIconV2;
